import React from 'react';

export const Truncate: React.FC<{
  children: React.ReactNode;
  title?: string;
  className?: string;
}> = ({ children, title, className = '' }) => (
  <div className={`min-w-0 truncate ${className}`} title={typeof title === 'string' ? title : undefined}>
    {children}
  </div>
);

export function formatEnabledFor(
  enabledFor: Record<string, number> | null | undefined,
  clientId: number | null | undefined,
) {
  if (!enabledFor || Object.keys(enabledFor).length === 0) {
    return '—';
  }
  return Object.entries(enabledFor).map(([domain, count]) => (
    <div key={domain} className="flex justify-between gap-4 whitespace-nowrap">
      {clientId ? (
        <span>{domain}</span>
      ) : (
        <>
          <span>{domain} Clients:</span>
          <span>{count}</span>
        </>
      )}
    </div>
  ));
}

export const TagList: React.FC<{ tags: string[] }> = ({ tags }) => {
  if (!tags.length) {
    return (
      <div className="flex justify-end">
        <span className="text-xs text-gray-400">No tags</span>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap justify-end gap-2">
      {tags.map((tag) => (
        <span key={tag} className="rounded-md bg-gray-200 px-2 py-1 text-xs font-semibold text-gray-700">
          {tag}
        </span>
      ))}
    </div>
  );
};

export const EmptyState: React.FC<{ message: string }> = ({ message }) => (
  <div className="rounded-md border border-dashed border-gray-300 p-10 text-center text-sm text-gray-500">
    {message}
  </div>
);
